import React from 'react';
import {
  Assignment as AssignmentIcon,
  Bolt as BoltIcon,
  CalendarMonth as CalendarIcon,
  Dashboard as DashboardIcon,
  FolderSpecial as ProjectIcon,
  Assessment as ReportIcon,
  People as PeopleIcon,
  PersonSearch as LeadIcon,
  Receipt as ReceiptIcon,
  Badge as StaffIcon,
  Payments as PaymentIcon,
} from '@mui/icons-material';
import type { SpotlightIconId } from './actionCatalog';

export const spotlightActionIcon = (icon: SpotlightIconId): React.ReactNode => {
  switch (icon) {
    case 'appointment':
      return <CalendarIcon fontSize="small" />;
    case 'patient':
      return <PeopleIcon fontSize="small" />;
    case 'lead':
      return <LeadIcon fontSize="small" />;
    case 'task':
      return <AssignmentIcon fontSize="small" />;
    case 'project':
      return <ProjectIcon fontSize="small" />;
    case 'expense':
      return <ReceiptIcon fontSize="small" />;
    case 'dashboard':
      return <DashboardIcon fontSize="small" />;
    case 'payment':
      return <PaymentIcon fontSize="small" />;
    case 'staff':
      return <StaffIcon fontSize="small" />;
    case 'report':
      return <ReportIcon fontSize="small" />;
    case 'flash':
      return <BoltIcon fontSize="small" />;
    default:
      return <BoltIcon fontSize="small" />;
  }
};
